<template>
  <!-- eslint-disable max-len -->
  <svg
    :aria-label="ariaLabel"
    :height="height"
    :width="width"
    viewBox="0 0 37 26"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M35.2188 1.28125C36.2344 2.21875 36.2344 3.85938 35.2188 4.79688L15.2188 24.7969C14.2812 25.8125 12.6406 25.8125 11.7031 24.7969L1.70312 14.7969C0.6875 13.8594 0.6875 12.2188 1.70312 11.2812C2.64062 10.2656 4.28125 10.2656 5.21875 11.2812L13.4219 19.4844L31.7031 1.28125C32.6406 0.265625 34.2812 0.265625 35.2188 1.28125Z"
      :fill="iconColor || '#42A854'"
    />
    <path
      d="M35.2188 1.28125L34.4839 1.95953L34.5111 1.98892L34.5405 2.01605L35.2188 1.28125ZM35.2188 4.79688L34.5405 4.06207L34.5258 4.07563L34.5116 4.08977L35.2188 4.79688ZM15.2188 24.7969L14.5116 24.0898L14.4975 24.1039L14.4839 24.1186L15.2188 24.7969ZM11.7031 24.7969L12.4379 24.1186L12.4244 24.1039L12.4102 24.0898L11.7031 24.7969ZM1.70312 14.7969L2.41023 14.0898L2.3961 14.0756L2.38141 14.0621L1.70312 14.7969ZM1.70312 11.2812L2.38141 12.0161L2.4108 11.9889L2.43793 11.9595L1.70312 11.2812ZM5.21875 11.2812L4.48395 11.9595L4.49751 11.9742L4.51164 11.9884L5.21875 11.2812ZM13.4219 19.4844L12.7148 20.1915L13.4204 20.8971L14.1275 20.193L13.4219 19.4844ZM31.7031 1.28125L32.4087 1.98987L32.4236 1.97501L32.4379 1.95953L31.7031 1.28125ZM34.5405 2.01605C35.1271 2.55759 35.1271 3.52053 34.5405 4.06207L35.897 5.53168C37.3416 4.19822 37.3416 1.87991 35.897 0.546446L34.5405 2.01605ZM34.5116 4.08977L14.5116 24.0898L15.9259 25.504L35.9259 5.50398L34.5116 4.08977ZM14.4839 24.1186C13.9424 24.7053 12.9795 24.7053 12.4379 24.1186L10.9683 25.4752C12.3018 26.9197 14.6201 26.9197 15.9536 25.4752L14.4839 24.1186ZM12.4102 24.0898L2.41023 14.0898L0.996018 15.504L10.996 25.504L12.4102 24.0898ZM2.38141 14.0621C1.79474 13.5205 1.79474 12.5576 2.38141 12.0161L1.02484 10.5464C-0.41974 11.8799 -0.41974 14.1982 1.02484 15.5317L2.38141 14.0621ZM2.43793 11.9595C2.97947 11.3729 3.94241 11.3729 4.48395 11.9595L5.95355 10.603C4.62009 9.15838 2.30178 9.15838 0.968322 10.603L2.43793 11.9595ZM4.51164 11.9884L12.7148 20.1915L14.129 18.7773L5.92586 10.5741L4.51164 11.9884ZM14.1275 20.193L32.4087 1.98987L30.9975 0.572631L12.7163 18.7758L14.1275 20.193ZM32.4379 1.95953C32.9795 1.37286 33.9424 1.37286 34.4839 1.95953L35.9536 0.60297C34.6201 -0.841615 32.3018 -0.841615 30.9683 0.60297L32.4379 1.95953Z"
      :fill="iconColor || '#42A854'"
    />
  </svg>
</template>

<script>
import BaseIcon from 'mixins/BaseIcon';

export default {
  mixins: [BaseIcon],
  props: {
    ariaLabel: {
      type: String,
      default: 'Correct'
    }
  }
};
</script>
